import { RicosViewer } from "./../ricos-viewer-next";
import { createWixRicosViewer } from "./WixRicosViewerNext";
const WixRicosViewer = createWixRicosViewer(RicosViewer);
export {
  WixRicosViewer
};
//# sourceMappingURL=index.js.map
